export default {"src":"https://fishbrain.com/_next/static/media/nevada.4a93856a.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};